export enum LocationTypes {
  retailStoreFront = 'Retail Store Front',
  officeBuilding = 'Office Building',
  residence = 'Residence',
  industrialBuilding = 'Industrial Building',
  tradeShow = 'Trade Show',
  mobile = 'Mobile',
}
